export default "__VITE_ASSET__BwPIg1Xu__$_?no-inline__"